import PrimaryDataCard from './PrimaryDataCard'
import MapCard from './MapCard'
import AgendaCard from './AgendaCard'
import RecentNotesCard from './RecentNotesCard'
import RecentContactMomentsCard from './RecentContactMomentsCard'
import MaterialsUsedCard from './MaterialsUsedCard'
import Co2SavedCard from './Co2SavedCard'
import SocietalSavingsCard from './SocietalSavingsCard'
import StatusHistoryCard from '../../statusHistory/StatusHistoryCard'
import ResearchCard from './ResearchCard'
import Location from '../../../hooks/Location'

const AdressDashboard = ({ adressNavigation }) => {
    const adressId = Location()[3]

    return (
        <div className={`adress-dashboard ${adressNavigation === 'dashboard' ? '' : 'adress-dashboard-hidden'}`}>
            <div className="new-dashboard-grid">
                <PrimaryDataCard />
                {/* `active` bepaalt of de kaart überhaupt opgebouwd wordt: Leaflet
                    bouwt zichzelf stuk in een blok dat met `display: none`
                    verborgen is, en herstelt zich daarna niet meer.
                    AI-CONTEXT: See docs/pitfalls.md#ui-component-mounted-hidden-keeps-a-zero-box */}
                <MapCard active={adressNavigation === 'dashboard'} />
                <AgendaCard />
                <RecentNotesCard />
                <RecentContactMomentsCard />
                <ResearchCard />
                <StatusHistoryCard entityType="adress" entityID={adressId} />
                <MaterialsUsedCard />
                <Co2SavedCard />
                <SocietalSavingsCard />
            </div>
        </div>
    )
}

export default AdressDashboard
